<template>
    <ul>
    <li class='mt-3' v-bind:key='index' v-for='(item,index) in data'>{{item}}</li>
</ul>
</template>

<script>
export default {
    props : {
        data : Array
    }
}
</script>

<style>

</style>
